import { createSlice } from "@reduxjs/toolkit"

const imageSlice = createSlice({
    name: "image",
    initialState: {
        images: [],
        isFetching: false,
        error: null
    },
    reducers: {
        imageStart: (state) => {
            state.isFetching = true
        },
        imageFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        getImageSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.images = action.payload
        },
        deleteImageSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.images.splice(
                state.images.findIndex((item) => item._id === action.payload),
                1
            )
        },
        updateImageSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.images[state.images.findIndex((item) => item._id === action.payload.id)] = action.payload.image
        },
        createImageSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.images.push(action.payload)
        }
    }
})

export const {
    imageStart,
    imageFailure,
    getImageSuccess,
    deleteImageSuccess,
    updateImageSuccess,
    createImageSuccess } = imageSlice.actions
    
export default imageSlice.reducer
